import { FC } from "react";
import { Text } from "@otrium/atoms";
import { Flex } from "@otrium/core";
import { Filtering } from "src/icons/Filtering";
import { connectCurrentRefinements } from "react-instantsearch-dom";
import { CurrentRefinementsProvided } from "react-instantsearch-core";
import { find } from "lodash-es";
import { Trans } from "@lingui/macro";
import {
  CATEGORIES_FACET,
  AGES_FACET,
  COLOUR_FACET,
  PATTERN_FACET,
  PRICE_FACET,
  SIZE_FACET,
  STYLE_FACET,
  BRAND_FACET,
  CONSCIOUS_FACET,
  DISCOUNT_FACET,
} from "src/utils/algolia";
import { filterFacets } from "src/organisms/AlgoliaProductList/utils/filterFacets";

interface Props extends CurrentRefinementsProvided {
  excludedFacetsList?: string[];
  keepSelectedIgnoreInActive?: { [p: string]: string[] };
  selectedCatSlug?: string[];
}

const StateResultsButton: FC<Props> = ({
  items,
  keepSelectedIgnoreInActive,
  excludedFacetsList = [],
  selectedCatSlug,
}) => {
  const facets = [
    filterFacets(
      find(items, { attribute: CATEGORIES_FACET }),
      keepSelectedIgnoreInActive,
      selectedCatSlug
    ),
    find(items, { attribute: COLOUR_FACET }),
    find(items, { attribute: PRICE_FACET }),
    find(items, { attribute: SIZE_FACET }),
    find(items, { attribute: STYLE_FACET }),
    find(items, { attribute: PATTERN_FACET }),
    find(items, { attribute: AGES_FACET }),
    find(items, { attribute: BRAND_FACET }),
    find(items, { attribute: CONSCIOUS_FACET }),
    find(items, { attribute: DISCOUNT_FACET }),
  ];

  let activeFacetsCount = 0;

  facets.forEach((facet) => {
    if (facet && !excludedFacetsList.includes(facet.attribute)) {
      activeFacetsCount +=
        facet.attribute !== PRICE_FACET && facet.attribute !== DISCOUNT_FACET
          ? facet.currentRefinement.length
          : 1;
    }
  });

  return (
    <Flex py={2}>
      <Filtering />
      <Text display="flex" fontWeight={600} ml={2} color={"Black"}>
        <Trans>Filters</Trans>
        {activeFacetsCount !== 0 && <Text>({activeFacetsCount})</Text>}
      </Text>
    </Flex>
  );
};

const FiltersButton = connectCurrentRefinements(StateResultsButton);

export default FiltersButton;
